import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminEditarContratoPage } from "@/features/admin-contratos-anualizados/components/AdminEditarContratoPage";
import { contratoAdminQueryOptions } from "@/features/admin-contratos-anualizados/hooks/use-contratos";

export const Route = createFileRoute("/_authed-tw/admin/contratos-anualizados/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(contratoAdminQueryOptions(id)),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminEditarContratoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
